<template>
   <van-overlay :show="showPhone">
        <div class="box">
              <p class="num">{{combinPhone}}</p>
              <div class="bth">
                    <span @click="cancal">取消</span>
                  <span @click="confirm">呼叫</span>
                  <!--<span @click="sendMessage" v-if="showMessage">发消息</span>-->
              </div>
        </div>
   </van-overlay>
</template>
<script>
	import api from 'apis'
    export default {
        props: {
            combinPhone: {
                // type: String,
                default: '07132068476'
            },
            userInfo: {
                type: Object,
                default: function () {
                    return {
                        userId: '',
	                    targetId: ''
                    }
                }
            }
        },
        computed: {
            showMessage() {
                return !!this.userInfo.targetId && !!this.userInfo.userId
            }
        },
        data () {
            return {
                showPhone: false
            }
        },
        created () {

        },
        methods: {
            showBox () {
                this.showPhone = true;
            },
            cancal () {
                this.showPhone = false;
            },
            confirm () {
                window.location.href = 'tel://' + this.combinPhone;
            },
	        async sendMessage() {
		        if (this.userInfo.name) {
			        await api.importAccount({
				        nick: this.userInfo.name,
				        identifier: `yjg_${this.userInfo.userId}`
			        });
		        }
		        if (this.userInfo.targetName) {
			        await api.importAccount({
				        nick: this.userInfo.targetName,
				        identifier: `yjg_${this.userInfo.targetId}`
			        });
		        }
		        let value = {
			        targetId: this.userInfo.targetId,
			        userId: this.userInfo.userId
		        };
		        let str = [];
		        for (let key in value) {
			        str.push(key + '=' + value[key]);
		        }
		        let query = str.join('&');
		        if (process.env.NODE_ENV === 'development') {
			        this.$router.push({
				        path: `/personalChat?${query}`
			        })
		        }
		        window.yyn.invokeJSB(
			        'openWindow',
			        {
				        openUrl: `${this.globalApp.getSystemInfo().host}web/#/personalChat?${query}`,
				        isFullScreen: 1,
				        setTitle: '',
				        needLoading: 1
			        },
			        cb => {
				        console.log(cb, 'callback');
			        }
		        );
	        }

        }
    }
</script>
<style lang="less" scoped>
 .box{
     width:260px;
     height:144px;
     background-color: #fff;
     position:fixed ;
     left:50%;
     top:50%;
     margin-left:-130px;
     margin-top:-72px;
     border-radius: 6px;
     text-align: center;
     .num{
         padding-top:36px;
         font-size:18px;
         color:#333;
         font-weight: 700;
     }
     .bth{
         display: flex;
         display: -webkit-flex;
         flex-direction: row;
         justify-content: space-around;
         margin-top:36px;
         padding: 0 16px;
         font-size: 0;
        //  display: inline-block;
         span{
            display: inline-block;
            width:110px;
            // height:38px;
            padding:12px 0;
            text-align: center;
            // line-height: 38px;
            color:#999999;
            font-size:14px;
            border:1px solid #CCCCCC;
            border-radius: 3px;
         }
         span:nth-child(2){
            // padding:12px 24px;
            background-color: @base-color;
            color:#fff;
            border:1px solid @base-color;
            margin-left: 8px;
            font-size:14px;
         }

         span:nth-child(3){
             // padding:12px 24px;
             background-color: @base-color;
             color:#fff;
             border:1px solid @base-color;
             margin-left: 8px;
             font-size:14px;
         }

     }
 }
</style>
<style>
.van-overlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
    z-index:99!important;
}
</style>
